import {
  FeaturesWrapper,
  FeaturesContainer,
  BentoGrid,
  FeatureCard,
  CardIcon,
  CardLabel,
  CardTitle,
  CardDescription,
} from "./styled";
import { H2, P } from "../../../components/typography/styled";
import { features } from "../../../config/home/features";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faPercent,
  faCheckCircle,
  faDashboard,
} from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  calculator: faCalculator,
  percent: faPercent,
  checkmark: faCheckCircle,
  dashboard: faDashboard,
};

export const Features = () => {
  return (
    <FeaturesWrapper id="features">
      <FeaturesContainer>
        <H2 style={{ textAlign: "center", marginBottom: "0.1rem" }}>
          Precision-Engineered Features
        </H2>
        <P style={{ textAlign: "center", marginBottom: "var(--flexGap)" }}>
          Everything you need to manage a modern workforce in one unified
          ledger.
        </P>

        <BentoGrid>
          {features.map((feature) => (
            <FeatureCard
              key={feature.id}
              backgroundColor={feature.backgroundColor}
              textColor={feature.textColor}
              gridPosition={feature.gridPosition}
            >
              {feature.label && <CardLabel>{feature.label}</CardLabel>}
              <CardIcon textColor={feature.textColor}>
                <FontAwesomeIcon icon={iconMap[feature.icon]} />
              </CardIcon>
              <CardTitle textColor={feature.textColor}>
                {feature.title}
              </CardTitle>
              <CardDescription textColor={feature.textColor}>
                {feature.description}
              </CardDescription>
            </FeatureCard>
          ))}
        </BentoGrid>
      </FeaturesContainer>
    </FeaturesWrapper>
  );
};
